export default __webpack_public_path__ + "static/media/intro2.ea295ecd.mp3";